import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { triggerHaptic, HapticPatterns } from '../utils/haptics';
import { PartyIcon, TargetIcon, HeartIcon } from '../icons';

function FABMenu({ isOpen, onClose }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleMenuItemClick = (path) => {
    triggerHaptic(HapticPatterns.medium);
    navigate(path);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="fab-backdrop" onClick={onClose} />

      {/* FAB Menu */}
      <div className="fab-menu">
        <button
          className="fab-menu-item fab-menu-event"
          onClick={() => handleMenuItemClick('/events/new')}
          aria-label={t('create_event')}
        >
          <div className="fab-menu-item-icon">
            <PartyIcon width="24" height="24" />
          </div>
          <span className="fab-menu-item-label">{t('create_event')}</span>
        </button>

        <button
          className="fab-menu-item fab-menu-challenge"
          onClick={() => handleMenuItemClick('/challenges/create')}
          aria-label={t('create_challenge')}
        >
          <div className="fab-menu-item-icon">
            <TargetIcon width="24" height="24" />
          </div>
          <span className="fab-menu-item-label">{t('create_challenge')}</span>
        </button>

        <button
          className="fab-menu-item fab-menu-wishlist"
          onClick={() => handleMenuItemClick('/wishlist?create=true')}
          aria-label={t('create_wishlist_idea')}
        >
          <div className="fab-menu-item-icon">
            <HeartIcon width="24" height="24" />
          </div>
          <span className="fab-menu-item-label">{t('create_wishlist_idea')}</span>
        </button>
      </div>
    </>
  );
}

export default FABMenu;
